import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import PublicDevices from '@features/publicDevices';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export const Component = () => {
  const { _ } = useLingui();
  return (
    <>
      <Helmet>
        <title>
        {_(msg`Telemetría`)} | Capta Hydro | Amaru
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <PublicDevices />
      </Box>
    </>
  );
};
